const PLACEHOLDER_IMAGE_PATTERNS = [
    'default-food-image',
    'default_product',
    'default-product',
    'placeholder',
    'no-image',
    'noimage',
];
export function isPlaceholderProductImage(url) {
    const value = (url || '').trim();
    if (!value)
        return true;
    const lower = value.toLowerCase();
    return PLACEHOLDER_IMAGE_PATTERNS.some((pattern) => lower.includes(pattern));
}
export function sanitizeProductImageUrl(url) {
    const value = (url || '').trim();
    if (!value || isPlaceholderProductImage(value)) {
        return undefined;
    }
    return value;
}
